import PublicPageService from '@services/publicPage.service';

const state = {
    ip_data: {},
    vehicles: [],
    other_location_id: 6,
    one_hour_percent: 4.1
};

const mutations = {
    ['SET_IP_DATA'](state, data) {
        state.ip_data = data;
    },
    ['SET_PUBLIC_VEHICLES'](state, data) {
        state.vehicles = data;
    }
};
const actions = {
    ['GET_IP_DATA']({commit, getters}) {
        if (Object.keys(getters.ipData).length) {
            return false;
        }
        PublicPageService.ipData().then(res => {
            commit('SET_IP_DATA', res);
        });
    },
    ['GET_PUBLIC_VEHICLES']({commit, getters}) {
        if (getters.publicVehicles.length) {
            return false;
        }
        PublicPageService.vehicles().then(res => {
            commit('SET_PUBLIC_VEHICLES', res);
        });
    }
};
const getters = {
    ipData: state => state.ip_data,
    publicVehicles: state => state.vehicles,
    otherLocationId: state => state.other_location_id,
    oneHourPercent: state => state.one_hour_percent,
};

export default {
    state,
    mutations,
    actions,
    getters
};
